import { Api } from "@/services/Api";
import store from "../store";

export default {
  viewBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("cancel/view", data, {
      headers
    });
  },
  viewCancellationDetails(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("cancel/details/view", data, {
      headers
    });
  },
  cancelBooking(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("cancel/booking", data, {
      headers
    });
  }
};
